export default {"src":"/_next/static/media/mail.bb775bae.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};